"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseDeleteTarifPeage = UseDeleteTarifPeage;
const react_1 = require("react");
const yup_1 = require("@hookform/resolvers/yup");
const react_hook_form_1 = require("react-hook-form");
const yup = __importStar(require("yup"));
const sweetalert2_1 = __importDefault(require("sweetalert2"));
const theme_1 = require("../../../../utils/theme");
const Utils_1 = require("../../../../utils/Utils");
const tarif_api_1 = require("../../../../utils/api/tarif/tarif.api");
const vehicule_api_1 = require("../../../../utils/api/vehicule/vehicule.api");
const point_peage_api_1 = require("../../../../utils/api/point-peage/point-peage.api");
const validationSchema = yup.object().shape({
    pricings: yup
        .array()
        .of(yup.object().shape({
        price: yup.string().required("Prix requis"),
        vehicule_type_id: yup
            .number()
            .required("Type de véhicule requis"),
        toll_point_id: yup.number().required("Poste de péage requis"),
    }))
        .min(1, "Ajoutez au moins un tarif"),
});
const UseAddTarifPeage = (handleClose) => {
    var _a, _b;
    const [addOrUpdateTarif, { isLoading, isSuccess, error, isError }] = (0, tarif_api_1.useAddOrUpdateTarifMutation)();
    const { register, handleSubmit, formState: { errors }, control, reset, clearErrors, } = (0, react_hook_form_1.useForm)({
        defaultValues: {
            pricings: [{ toll_point_id: 0, vehicule_type_id: 0, price: "" }],
        },
        resolver: (0, yup_1.yupResolver)(validationSchema),
    });
    const { fields, append, remove } = (0, react_hook_form_1.useFieldArray)({
        control,
        name: "pricings",
    });
    const { data: typeVehicules = { data: [] } } = (0, vehicule_api_1.useGetVehiculesQuery)({});
    const { data: pointPeages = { data: [] } } = (0, point_peage_api_1.useGetPointPeagesQuery)({});
    const typeVehiculeOptions = ((_a = typeVehicules === null || typeVehicules === void 0 ? void 0 : typeVehicules.data) === null || _a === void 0 ? void 0 : _a.map((type) => ({
        label: type === null || type === void 0 ? void 0 : type.name,
        value: type === null || type === void 0 ? void 0 : type.id,
    }))) || [];
    const tollPointOptions = ((_b = pointPeages === null || pointPeages === void 0 ? void 0 : pointPeages.data) === null || _b === void 0 ? void 0 : _b.map((peage) => ({
        label: peage === null || peage === void 0 ? void 0 : peage.name,
        value: peage === null || peage === void 0 ? void 0 : peage.id,
    }))) || [];
    const onSubmit = (0, react_1.useCallback)((data) => {
        console.log("send", data);
        addOrUpdateTarif({ data: data });
    }, [addOrUpdateTarif]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (isSuccess) {
            sweetalert2_1.default.fire({
                icon: "success",
                title: "Tarifs ajoutés avec succès !",
                iconColor: theme_1.Color.success,
                showConfirmButton: false,
                timer: 1500,
            }).then(() => {
                reset();
                handleClose();
            });
        }
        if (isError) {
            sweetalert2_1.default.fire({
                icon: "error",
                title: ((_a = error === null || error === void 0 ? void 0 : error.data) === null || _a === void 0 ? void 0 : _a.message) || "Erreur lors de l'ajout",
                iconColor: theme_1.Color.danger,
                showConfirmButton: true,
                confirmButtonColor: theme_1.Color.default
            });
        }
    }, [isSuccess, isError]);
    (0, react_1.useEffect)(() => {
        (0, Utils_1.cleannerError)(errors, clearErrors);
    }, [errors]);
    return {
        register,
        errors,
        control,
        onSubmit: handleSubmit(onSubmit),
        isLoading,
        fields,
        append,
        remove,
        typeVehiculeOptions,
        tollPointOptions,
    };
};
exports.default = UseAddTarifPeage;
function UseDeleteTarifPeage(id) {
    const [deleteData] = (0, tarif_api_1.useDeleteTarifMutation)();
    const onDelete = () => __awaiter(this, void 0, void 0, function* () {
        yield sweetalert2_1.default.fire({
            title: `Êtes-vous sûr de vouloir supprimer ce tarif ?`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "OUI",
            cancelButtonText: "NON",
            showLoaderOnConfirm: true,
            iconColor: theme_1.Color.themeColor,
            confirmButtonColor: theme_1.Color.themeColor,
            preConfirm: () => {
                return deleteData(id);
            },
            allowOutsideClick: () => !sweetalert2_1.default.isLoading(),
        }).then((result) => {
            if (result === null || result === void 0 ? void 0 : result.value) {
                sweetalert2_1.default.fire({
                    icon: "success",
                    title: `Tarif supprimé avec succès!`,
                    iconColor: theme_1.Color.themeColor,
                    showConfirmButton: false,
                    timer: 1500,
                });
            }
        });
    });
    return onDelete;
}
